"use client";

import "./index.css";
import { useEffect, useMemo, useRef, useState } from "react";
import Image from "next/image";
import { useScroll } from "ahooks";
import { formatCurrency, getValueByKeyV2 } from "@/03-presenters/shared/helper";
import Ellipsis from "@/03-presenters/components/ui/Ellipsis";
import Slogen from "./Slogen";
import { getHomepageUpdateTime } from "@/00-shared/const";
import Link from "next/link";
import { goldMedal, silverMedal, bronzeMedal } from "./svg";
import { cx } from "class-variance-authority";
import { CurrencyField, EntityV2, ImageField, ImageSeriesField } from "@/01-core/entity/entities/entityV2";
const icon = <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7" cy="7" r="7" fill="black" fillOpacity="0.25" />
    <path d="M4 6.5C3.72386 6.5 3.5 6.72386 3.5 7C3.5 7.27614 3.72386 7.5 4 7.5V6.5ZM10.3536 7.35355C10.5488 7.15829 10.5488 6.84171 10.3536 6.64645L7.17157 3.46447C6.97631 3.2692 6.65973 3.2692 6.46447 3.46447C6.2692 3.65973 6.2692 3.97631 6.46447 4.17157L9.29289 7L6.46447 9.82843C6.2692 10.0237 6.2692 10.3403 6.46447 10.5355C6.65973 10.7308 6.97631 10.7308 7.17157 10.5355L10.3536 7.35355ZM4 7.5H10V6.5H4V7.5Z" fill="white" />
  </svg>;
const baseHight = 5100;
const containerHeight = 600;
export function FourthBox({
  data
}: {
  data: EntityV2[][];
}) {
  const [clientdocument, setClientDocument] = useState<Document | null>(null);
  useEffect(() => {
    setClientDocument(document);
  }, []);
  const scroll = useScroll(clientdocument, val => val.top >= baseHight && val.top <= baseHight + 3 * containerHeight);
  const translateStyleList: React.CSSProperties[] = useMemo(() => {
    return [0, 1, 2, 3].map(index => {
      const diff = Math.max((Number(scroll?.top) - baseHight - containerHeight * index) / 6000, 0);
      return {
        transform: `scale3d(${1 - diff / 2}, ${1 - diff / 2}, 1)`
      };
    });
  }, [scroll]);
  return <div className="fourth-container bg-[#F4F4F8] py-16" data-sentry-component="FourthBox" data-sentry-source-file="FourthBox.tsx">
      <Slogen content={<div className="flex flex-col items-center gap-4">
            <div className="text-xl font-semibold sm:text-[30px]">
              跟踪六大维度数据，掌握市场趋势动态
            </div>
            <div className="text-wrap text-[rgba(0,0,0,0.45)] sm:text-nowrap">
              为商家、达人、供应链、MCN
              机构等提供商品、店铺、达人、视频、广告、直播六大维度兴趣电商动态信息
            </div>
          </div>} data-sentry-element="Slogen" data-sentry-source-file="FourthBox.tsx" />
      <div id="cards">
        <div className="card" id="card1" style={translateStyleList[0]}>
          <div className="mx-auto flex flex-col items-center justify-between rounded-lg p-4 backdrop-blur-sm sm:h-[600px] sm:w-[1344px] sm:flex-row sm:pl-24 sm:pr-16" style={{
          background: "url(/homepage/colorBackground2.webp) no-repeat"
        }}>
            <div>
              <Image height={257} width={204} style={{
              width: "204px",
              height: "257px",
              objectFit: "cover"
            }} src="/homepage/image2.webp" alt="image" className="hidden sm:block" data-sentry-element="Image" data-sentry-source-file="FourthBox.tsx"></Image>
              <div className="mb-2 sm:mb-0 sm:translate-y-6">
                <div className="font-bold text-white sm:text-[60px]">
                  选爆品
                </div>
                <div className="text-white">
                  快速挖掘销量爆发增长商品，解析爆品营销案例。
                </div>
              </div>
            </div>
            <CommonCardList entityList={data[0]} CardChild={ProductCard} href="tiktok/entity/tiktok_product/product_sold_count_view" data-sentry-element="CommonCardList" data-sentry-source-file="FourthBox.tsx" />
          </div>
        </div>
        <div className="card" id="card2" style={translateStyleList[1]}>
          <div className=" mx-auto flex flex-col items-center justify-between rounded-lg p-4 backdrop-blur-sm sm:h-[600px] sm:w-[1344px] sm:flex-row sm:pl-24 sm:pr-16" style={{
          background: "url(/homepage/colorBackground3.webp) no-repeat"
        }}>
            <div>
              <Image height={232} width={335} style={{
              width: "335px",
              height: "232px",
              objectFit: "cover",
              marginBottom: "20px"
            }} src="/homepage/image3.webp" alt="image" className="hidden sm:block" data-sentry-element="Image" data-sentry-source-file="FourthBox.tsx"></Image>
              <div className="mb-2 sm:mb-0 sm:translate-y-6">
                <div className="font-bold text-white sm:text-[60px]">
                  查店铺
                </div>
                <div className=" text-white">
                  查看热销店铺数据，了解对手运营动作，优化店铺运营。
                </div>
              </div>
            </div>
            <CommonCardList entityList={data[1]} CardChild={SellerCard} href="tiktok/entity/tiktok_seller/shop_sold_count_view" data-sentry-element="CommonCardList" data-sentry-source-file="FourthBox.tsx" />
          </div>
        </div>
        <div className="card" id="card3" style={translateStyleList[2]}>
          <div className=" mx-auto flex flex-col items-center justify-between rounded-lg p-4 backdrop-blur-sm sm:h-[600px] sm:w-[1344px] sm:flex-row sm:pl-24 sm:pr-16" style={{
          background: "url(/homepage/colorBackground1.webp) no-repeat"
        }}>
            <div>
              <Image height={270} width={231} style={{
              width: "270px",
              height: "231px",
              objectFit: "cover"
            }} src="/homepage/image1.webp" alt="image" className="hidden sm:block" data-sentry-element="Image" data-sentry-source-file="FourthBox.tsx"></Image>
              <div className="mb-2 sm:mb-0 sm:translate-y-9">
                <div className="font-bold text-white sm:text-[60px]">
                  挑达人
                </div>
                <div className="text-white">
                  高效挖掘优质带货达人，解析达人粉丝画像，查看达人联系方式快速建联。
                </div>
              </div>
            </div>
            <CommonCardList entityList={data[2]} CardChild={CreatorCard} customClassName="top-[1.4rem] left-4" href="tiktok/entity/tiktok_creator/creator_ecommerce_creators_view" data-sentry-element="CommonCardList" data-sentry-source-file="FourthBox.tsx" />
          </div>
        </div>
        <div className="card" id="card4" style={translateStyleList[3]}>
          <div className=" mx-auto flex flex-col items-center justify-between rounded-lg p-4 backdrop-blur-sm sm:h-[600px] sm:w-[1344px] sm:flex-row sm:pl-24 sm:pr-16" style={{
          background: "url(/homepage/colorBackground4.webp) no-repeat"
        }}>
            <div>
              <Image height={205} width={216} style={{
              width: "216px",
              height: "205px",
              objectFit: "cover",
              marginBottom: "20px"
            }} src="/homepage/image4.webp" alt="image" className="hidden sm:block" data-sentry-element="Image" data-sentry-source-file="FourthBox.tsx"></Image>
              <div className="mb-2 sm:mb-0 sm:translate-y-10">
                <div className="font-bold text-white sm:text-[60px]">
                  看直播
                </div>
                <div className=" text-white">
                  解析带货直播生态数据，快速查看高GMV带货直播间数据。
                </div>
              </div>
            </div>
            <CommonCardList entityList={data[3]} CardChild={LiveCard} href="tiktok/entity/tiktok_live/search" data-sentry-element="CommonCardList" data-sentry-source-file="FourthBox.tsx" />
          </div>
        </div>
      </div>
    </div>;
}
interface CardChildProps {
  num: number;
  entity: EntityV2;
}
function CreatorCard({
  entity,
  num
}: CardChildProps) {
  const creatorNickName = getValueByKeyV2(entity, "tiktok_creator_commercial_nickname") as string;
  const totalVideoLive1dGmv = getValueByKeyV2(entity, "titkok_creator_commercial_interval_total_video_live_gmv") as CurrencyField["value"];
  const creatorAvatar = getValueByKeyV2(entity, "tiktok_creator_commercial_user_avatar") as ImageField["value"];
  const creatorUniqueId = getValueByKeyV2(entity, "tiktok_creator_commercial_unique_id") as string;
  const [imgSrc, setImgSrc] = useState(creatorAvatar?.url);
  return <div className=" flex items-center justify-between gap-2 rounded-lg bg-[rgb(0,0,0,0.2)] p-6 sm:w-[490px]" data-sentry-component="CreatorCard" data-sentry-source-file="FourthBox.tsx">
      <div className="flex gap-3">
        <Image height={72} width={72} style={{
        objectFit: "cover",
        borderRadius: "50%"
      }} src={imgSrc} onError={() => setImgSrc("/fallbackImage/creator.svg")} alt={"logo"} data-sentry-element="Image" data-sentry-source-file="FourthBox.tsx"></Image>
        <div className="flex flex-col">
          <div className="text-sm font-semibold text-[#fff] sm:text-[20px]">
            {creatorNickName}
          </div>
          <div className="text-xs text-[rgba(255,255,255,0.6)]">
            {creatorUniqueId}
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center gap-3">
        <div className="text-xs text-[rgba(255,255,255,0.6)]">昨日销售额</div>
        <div className="text-nowrap font-semibold text-[#fff] sm:text-[20px]">
          {formatCurrency(totalVideoLive1dGmv)}
        </div>
      </div>
    </div>;
}
function ProductCard({
  entity,
  num
}: CardChildProps) {
  const productTitle = getValueByKeyV2(entity, "tiktok_product_sold_count_product_name");
  const productImages = getValueByKeyV2(entity, "tiktok_product_sold_count_product_images") as ImageSeriesField["value"];
  const productDailyGmv = getValueByKeyV2(entity, "tiktok_product_sold_count_interval_gmv") as CurrencyField["value"];
  const [imgSrc, setImgSrc] = useState(productImages?.[0]?.url);
  return <div className="flex items-center justify-between gap-2 rounded-lg bg-[rgb(0,0,0,0.2)] p-6 sm:w-[490px]" data-sentry-component="ProductCard" data-sentry-source-file="FourthBox.tsx">
      <div className="flex gap-3">
        <Image height={72} width={72} style={{
        objectFit: "cover",
        borderRadius: "6px"
      }} src={imgSrc} onError={() => setImgSrc("/fallbackImage/product.svg")} alt={"logo"} data-sentry-element="Image" data-sentry-source-file="FourthBox.tsx"></Image>
        <div className="flex max-w-[24vw] flex-col sm:max-w-[240px]">
          <Ellipsis title={productTitle} data-sentry-element="Ellipsis" data-sentry-source-file="FourthBox.tsx">
            <span className="text-sm font-semibold text-[#fff] sm:text-[20px]">
              {productTitle}
            </span>
          </Ellipsis>
        </div>
      </div>
      <div className="flex flex-col items-center gap-3">
        <div className="text-xs text-[rgba(255,255,255,0.6)]">昨日销售额</div>
        <div className="text-nowrap font-semibold text-[#fff] sm:text-[20px]">
          {formatCurrency(productDailyGmv)}
        </div>
      </div>
    </div>;
}
function SellerCard({
  entity,
  num
}: CardChildProps) {
  const sellerAvatar = getValueByKeyV2(entity, "tiktok_seller_sold_count_seller_avatar") as ImageField["value"];
  const sellerName = getValueByKeyV2(entity, "tiktok_seller_sold_count_shop_name") as string;
  const sellerDailyGmv = getValueByKeyV2(entity, "tiktok_seller_sold_count_interval_gmv") as CurrencyField["value"];
  const [imgSrc, setImgSrc] = useState(sellerAvatar?.url);
  return <div className="flex items-center justify-between gap-2 rounded-lg bg-[rgb(0,0,0,0.2)] p-6 sm:w-[490px]" data-sentry-component="SellerCard" data-sentry-source-file="FourthBox.tsx">
      <div className="flex gap-3">
        <Image height={72} width={72} style={{
        objectFit: "cover",
        borderRadius: "6px"
      }} src={imgSrc} onError={() => setImgSrc("/fallbackImage/seller.svg")} alt={"logo"} data-sentry-element="Image" data-sentry-source-file="FourthBox.tsx"></Image>
        <div className="flex max-w-[24vw] flex-col sm:max-w-[240px]">
          <Ellipsis title={sellerName} data-sentry-element="Ellipsis" data-sentry-source-file="FourthBox.tsx">
            <span className="text-sm font-semibold text-[#fff] sm:text-[20px]">
              {sellerName}
            </span>
          </Ellipsis>
        </div>
      </div>
      <div className="flex flex-col items-center gap-3">
        <div className="text-xs text-[rgba(255,255,255,0.6)]">昨日销售额</div>
        <div className="text-nowrap font-semibold text-[#fff] sm:text-[20px]">
          {formatCurrency(sellerDailyGmv)}
        </div>
      </div>
    </div>;
}
function LiveCard({
  entity,
  num
}: CardChildProps) {
  const liveCover = getValueByKeyV2(entity, "tiktok_live_search_cover") as ImageField["value"];
  const liveTitle = getValueByKeyV2(entity, "tiktok_live_search_title") as string | undefined;
  const liveGmv = getValueByKeyV2(entity, "tiktok_live_search_gmv") as CurrencyField["value"];
  const [imgSrc, setImgSrc] = useState(liveCover?.url);
  return <div className="flex items-center justify-between gap-2 rounded-lg bg-[rgb(0,0,0,0.2)] p-6 sm:w-[490px]" data-sentry-component="LiveCard" data-sentry-source-file="FourthBox.tsx">
      <div className="flex gap-3">
        <Image height={72} width={72} style={{
        width: "72px",
        height: "72px",
        objectFit: "cover",
        borderRadius: "6px"
      }} src={imgSrc} onError={() => setImgSrc("/fallbackImage/live.svg")} alt={"logo"} data-sentry-element="Image" data-sentry-source-file="FourthBox.tsx"></Image>
        <div className="flex max-w-[24vw] flex-col sm:max-w-[240px]">
          <Ellipsis title={liveTitle || "无标题"} data-sentry-element="Ellipsis" data-sentry-source-file="FourthBox.tsx">
            <span className="text-sm font-semibold text-[#fff] sm:text-[20px]">
              {liveTitle || "无标题"}
            </span>
          </Ellipsis>
        </div>
      </div>
      <div className="flex flex-col items-center gap-3">
        <div className="text-xs text-[rgba(255,255,255,0.6)]">本场总销售额</div>
        <div className="text-nowrap font-semibold text-[#fff] sm:text-[20px]">
          {formatCurrency(liveGmv)}
        </div>
      </div>
    </div>;
}
function CommonCardList({
  entityList,
  CardChild,
  href,
  customClassName
}: {
  entityList: EntityV2[];
  CardChild: React.FC<CardChildProps>;
  href: string;
  customClassName?: string;
}) {
  const rankList = [goldMedal, silverMedal, bronzeMedal];
  const [isHover, setIsHover] = useState(false);
  const [homepageUpdateTime, setHomepageUpdateTime] = useState<string | null>(null);
  useEffect(() => {
    setHomepageUpdateTime(getHomepageUpdateTime());
  }, []);
  return <div className="custom-variability" data-sentry-component="CommonCardList" data-sentry-source-file="FourthBox.tsx">
      <div className="flex flex-col gap-4">
        {entityList.map((entity, index) => <div key={entity.entity_id} className="relative">
            <div className={cx("absolute left-3 top-3", customClassName)}>
              {rankList[index]}
            </div>
            <CardChild num={index} entity={entity} />
          </div>)}
      </div>
      <div className="mt-2 flex flex-col items-center justify-between gap-2 sm:flex-row sm:gap-0">
        <div className="text-right text-sm text-[rgba(0,0,0,0.4)]">
          {homepageUpdateTime}
        </div>
        <Link className="flex cursor-pointer items-center justify-end gap-1 pr-2 text-[14px]" href={href} onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)} data-sentry-element="Link" data-sentry-source-file="FourthBox.tsx">
          <div className="text-white sm:text-[rgba(0,0,0,0.5)]">
            查看完整榜单
          </div>
          <div>{icon}</div>
        </Link>
      </div>
    </div>;
}